/**
 * Created by Pali on 21/06/24.
 */

angular.module("screensApp")

  .controller("LotteryController", function ($scope, $rootScope) {

    // credentials from https://demo1.playbetman.com/
    // $rootScope.config.KironVisionXUserName = 'betman_games';
    // $rootScope.config.KironVisionXPassword = 'EB1E5D7F-9A34-451F-AA9F-7D3D0EEB580A';

    $scope.availableLanguages = ['en', 'pl', 'de', 'fr', 'ro'];
    $scope.language = 'en';
    $scope.disableEventTime = '0';

    //  Show lottery
    $rootScope.showLottery = function (data) {

      var kironID = '';
      $scope.iframe = null;
      $rootScope.lotteryURL = '';
      $rootScope.settings.winnersForBanner = false;

      if ($scope.availableLanguages.includes($rootScope.config.LanguageId)) {
        $scope.language = $rootScope.config.LanguageId;
      }

      switch (data.leagueID) {
        case 624205:
          // KRN Keno
            // from https://demo1.playbetman.com/ kironID = '141A7A40-5B01-4B36-8E5A-DF6735F7B974';
            // https://visionx.playbetman.com/?i=141A7A40-5B01-4B36-8E5A-DF6735F7B974&l=en
            kironID = $rootScope.config.KironVisionXKeno;
          break;
        case 624204:
          // KRN LuckyLoot
            // from https://demo1.playbetman.com/ kironID = '8BC58B3F-9090-4B99-8FD0-FB55FE58BD12';
            // https://visionx.playbetman.com/?i=8BC58B3F-9090-4B99-8FD0-FB55FE58BD12&l=en
            kironID = $rootScope.config.KironVisionXLuckyLoot;
          break;
        default:
          // Unrecognised leagueID - hide lottery
          $rootScope.hideLottery();
          break;
      }
      if (kironID.length) {
        // Show lotteryContainer
        $rootScope.settings.lottery.active = true;
        $rootScope.settings.lottery.show = true;
        $rootScope.lotteryURL = $rootScope.url.KironVisionXURL + '?i=' + kironID + '&l=' + $scope.language + '&det=' + $scope.disableEventTime;
      }

      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showLottery() data: ' + JSON.stringify(data) + ' lotteryURL: ' + $rootScope.lotteryURL);
      !$rootScope.$$phase && $rootScope.$apply();
    };

    // Hide lottery
    $rootScope.hideLottery = function () {
      // Hide lotteryContainer
      $rootScope.settings.lottery.show = false;
      $rootScope.settings.lottery.active = false;
      // Set iframe source to base VisionXURL
      $rootScope.lotteryURL = $rootScope.url.KironVisionXURL;
      // Get iframe and check
      $scope.iframe = $('#lotteryIframe').get(0);
      if ($scope.iframe) {
        // Hide iFrame to prevent any further loading
        $scope.iframe.style.display = 'none';
      }

      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideLottery()');
      !$rootScope.$$phase && $rootScope.$apply();
    };

    // Lottery iframe onload
    $scope.iframeLoadedCallBack = function() {
      // Get iframe and check
      $scope.iframe = $('#lotteryIframe').get(0);
      if ($scope.iframe == null || typeof $scope.iframe == 'undefined') {
        return;
      }
      if ($scope.iframe.src == $rootScope.url.KironVisionXURL) {
        return;
      }
      // Event listener for incoming messages from iframe
      window.addEventListener('message', processMessage, false);
      // Send credentials to iframe
      $scope.iframe.contentWindow.postMessage({ userName: $rootScope.config.KironVisionXUserName, password: $rootScope.config.KironVisionXPassword }, $rootScope.url.KironVisionXURL);
    };

    // Lottery incoming message from iframe
    function processMessage(obj) {
      //Check eceived the height
      if (obj.data.height) {
        // Get iframe and check
        if ($scope.iframe) {
          // Set iframe class and height
          $scope.iframe.classList.add('loaded');
          $scope.iframe.style.height = obj.data.height + 'px';
        }
      }
    }

  });
